module.exports = __webpack_public_path__ + "img/left.df48af05.svg";